import { TableBarItemDirective } from './table-bar-item/table-bar-item.directive';
import { TableBarSearchDirective } from './table-bar-search/table-bar-search.directive';

export const Directives = [
	TableBarItemDirective,
	TableBarSearchDirective,
];
